export default "__VITE_ASSET__7bb75e04__"